import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/submitting-estimate.svg'
import _imports_1 from '@/assets/icons/check-blue.svg'


const _withScopeId = n => (_pushScopeId("data-v-4e39627a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "submit_estimate_modal" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "loader_icon" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "checked"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader_progress_bar" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "progress progress_complete" }),
  /*#__PURE__*/_createElementVNode("div", { class: "progress" })
], -1))
const _hoisted_7 = { class: "tw-mt-6" }

import Button from "@/core/components/ui/general/Button.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'FinalEstimateSubmitLoadingModal',
  props: { step: { type: Number } },
  emits: ["onCancel"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const onCancel = () => {
  emit("onCancel");
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["card", { 'card--success': __props.step !== 0 }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", {
          class: _normalizeClass({ 'small-title': __props.step !== 0 })
        }, _toDisplayString(__props.step == 0 ? "Submitting Estimate" : "Estimate submitted."), 3),
        _createElementVNode("div", _hoisted_3, [
          (__props.step == 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : _createCommentVNode("", true),
          (__props.step == 1)
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (__props.step === 0)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                class: "button button-orange",
                onClick: onCancel,
                width: "100%"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.step === 1)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                class: "button button-orange",
                onClick: onCancel,
                width: "100%"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Okay")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2)
  ]))
}
}

})